export default {
  videoWrapper: {
    paddingTop: '15px',
    paddingBottom: '20px'
  },
  guideWrapper: {
    fontSize: '2rem',
    textAlign: 'center',
    paddingTop: '1rem'
  },
  guideIcon: {
    fontSize: '3.5rem',
    verticalAlign: '-8px',
    marginRight: '1rem',
    transform: 'rotate(15deg)'
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoPanel/style.js